import { Card, Skeleton } from "antd";
import React from "react";

export const SkeletonCard = () => {
	return (
		<Card style={{ marginTop: 16, height: 160, width: 600 }}>
			<Skeleton
				active
				avatar={{ shape: "square", size: 100 }}
				paragraph={{ rows: 1 }}
			></Skeleton>
		</Card>
	);
};
